import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDfxlzE6weu6AyHmJ9Fe9ddFm670MxZKM0",
    authDomain: "feed-production.firebaseapp.com",
    databaseURL: "https://feed-production.firebaseio.com",
    projectId: "feed-production",
    storageBucket: "feed-production.appspot.com",
    messagingSenderId: "924022935874",
    appId: "1:924022935874:web:9c41eaee4cbcdbe53438db"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Set persistence to LOCAL to keep user logged in across browser sessions
setPersistence(auth, browserLocalPersistence)
    .then(() => {
        console.log("Firebase auth persistence set to LOCAL");
    })
    .catch((error) => {
        console.error("Error setting auth persistence:", error);
    });

export { app, auth, db };


